<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                name: '',
                amount: '',
                description: '',
                file: '',
                user_id: '',
                files: [],
                billing_data_id: '',
                bank_account_providers_id: '',
                // currency_id: 1,

                // exchange: '',

                // change_date: '',
                // exchange_rate: '',
                // amount_usd: '',
            },
            bill: {
                type:{
                    name:''
                },
                company:{
                    name:''
                },
            },
            file: '',
            fileName: '',
            // xml: '',
            // xmlName: '',
            files: [],
            send: false,
            load: false,

            block: false,
            petty_cash: '',
            userCheck: '',
            userPay: ''
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.name = '';
            this.form.description = '';
            this.form.file = '';
            this.form.amount = '';
            this.form.bank_account_providers_id = '';
            // this.form.exchange = '';
            // this.form.currency_id = 1;
            if (this.authUser.organization_charts_id == 5) {
                this.form.user_id = this.authUser.id;
            } else {
                this.form.user_id = '';
            }
            this.form.billing_data_id = '';
            this.form.files = [];
            this.fileName = '';
            // this.xmlName = '';
            this.bill= {
                type:{
                    name:''
                },
                company:{
                    name:''
                },
            };
            this.file = '';
            // this.xml = '';
            this.block = false;
            this.files = [];
            this.send = false;
            this.errors = {};

            // this.form.change_date= '';
            // this.form.exchange_rate= '';
            // this.form.amount_usd= '';

            this.userCheck = '';
            this.userPay = '';

            this.$modal.hide('addBill');
        },
        uploadFilesBill(event) {
            let vm = this;

            let file = event.target.files[0];
            vm.form.files.push(file);
            this.$forceUpdate();
        },
        createURL(file) {
            let link = URL.createObjectURL(file);
            return link;
        },
        // calcTotalUSD() {
        //     this.bill.subtotal = this.form.exchange_rate * this.form.amount_usd;
        // },
        async delImgUpload(pos) {
            let img = this.files[pos];
            let id = img.id;
            let _endpoint = '/bills/deleted-documents';
            let form = {
                id: id
            };
            let { data } = await request.postMedia(_endpoint, form)
            if (data) {
                this.successNotification(data.message);
                this.files.splice(pos, 1);
            }

        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se elimino correctamente.');
        },
        catch_file(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.file = event.target.files[0];
                this.fileName = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        // catch_xml(event) {
        //     // console.log(event.target.files[0].type);
        //     if (event.target.files[0].type == "text/xml") {
        //         this.form.xml = event.target.files[0];
        //         this.xmlName = event.target.files[0].name;
        //         this.catchDataXML(event.target.files[0]);
        //     } else {
        //         this.$swal({
        //             icon: 'error',
        //             title: 'Error tipo de archivo',
        //             text: 'Solo se puede cargar archivos XML',
        //         });
        //     }
        // },
        // async catchDataXML(file) {
        //     // console.log(file);
        //     const data_form = new FormData();
        //     data_form.append('xml', file);

        //     let _endpoint = `/bill_load_xml`;

        //     try {
        //         let { data } = await request.postMedia(_endpoint, data_form)
        //         if (data) {
        //             if (data.company_id) {
        //             this.form.folio = data.Folio;
        //             this.form.tax_folio = data.UUID;
        //             this.form.subtotal = data.SubTotal;
        //             this.form.iva = data.iva;
        //             this.form.iva_ret = data.iva_ret;
        //             this.form.discount = data.Descuento;
        //             this.form.ieps = data.ieps;
        //             this.form.isr_ret = data.isr_ret
        //             if (data.currency_id) {
        //                 this.form.currency_id = data.currency_id;
        //             }
        //             if (data.bill_types_id) {
        //                 this.form.biill_type_id = data.bill_types_id;
        //             }
        //             if (data.company_id) {
        //                 this.form.company_id = data.company_id;
        //             }
        //             let DateBill = this.moment(data.Fecha).format('YYYY-MM-DD');
        //             this.form.date = DateBill;
        //             if (this.authUser.organization_charts_id != 2) {
        //                 if (data.user_id) {
        //                     this.form.user_id = data.user_id;
        //                 }
        //             }

        //             if (data.billing_data_id) {
        //                 this.form.billing_data_id = data.billing_data_id;
        //             }

        //             if (data.impuestos) {
        //                 this.form.billing_data_id = data.impuestos;
        //             }
        //             this.block = true;
        //             // } else {
        //             //     this.form.xml = '';
        //             //     this.xmlName = '';
        //             //     this.$swal({
        //             //         icon: 'error',
        //             //         title: 'No se puede cargar la factura',
        //             //         text: 'No se puede cargar porque la fecha de emisión es de otro mes'
        //             //     });
        //             }else{
        //                 this.form.xml = '';
        //                 this.xmlName = '';
        //                 this.$swal({
        //                     icon: 'error',
        //                     title: 'No se puede cargar la factura',
        //                     text: 'No se puede cargar porque la empresa no existe en el sistema'
        //                 });
        //             }
        //         }
        //     } catch (error) {
        //         this.send = false;
        //         this.errors = {};
        //         if (error.response) {

        //             this.errors = await this.errorNotification(error);
        //         }
        //     }

        // },
        async saveBills() {
            this.send = true;
            const data_form = new FormData();
            data_form.append('id', this.form.id);
            data_form.append('name', this.form.name);
            data_form.append('description', this.form.description??'');
            data_form.append('file', this.form.file);
            data_form.append('user_id', this.form.user_id);
            data_form.append('billing_data_id', this.form.billing_data_id);
            data_form.append('bank_account_providers_id', this.form.bank_account_providers_id);
            // data_form.append('currency_id', this.form.currency_id);

            // data_form.append('exchange', this.form.exchange);

            // data_form.append('change_date',this.form.change_date);
            // data_form.append('exchange_rate',this.form.exchange_rate);
            // data_form.append('amount_usd',this.form.amount_usd);

            this.form.files.forEach(function (valor, index) {
                data_form.append('files[' + index + ']', valor);
            });


            let _endpoint = `/bills/vault/${this.form.id}`;
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-bills');
                    Event.$emit('event-load-petty-cash-bill', this.petty_cash, data.id);
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {

                    this.errors = await this.errorNotification(error);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
        'form.user_id'(value) {
            this.catalogue.getBillingDataUser(value);
        },
        'form.name'(value) {
            let str = value;
            let oldText = str.slice(0, str.length - 1);

            if (this.form.id == '' && oldText == this.form.description) {
                this.form.description = value;
            }
        },
        'form.billing_data_id'(value) {
            if (!this.load) {
                this.form.bank_account_providers_id = '';
            }

            this.catalogue.getBankBillAccountProvider(value);

            if (this.load) {
                this.load = false;
            }

        },
        'catalogue.bank_bill_account_provider'(value) {
            if (value.length > 0) {
                let bank_account_providers_id = this.form.bank_account_providers_id;

                let existe = value.filter(function (account) {
                    return account.id === bank_account_providers_id ? true : false;
                });

                if (existe.length == 0) {
                    this.form.bank_account_providers_id = value[0].id;
                }
            }
        },
    },
    mounted() {
        this.catalogue.get_users_profile(5);
        this.catalogue.getCurrencies();

        if (this.authUser.organization_charts_id == 5) {
            this.form.user_id = this.authUser.id;
            this.catalogue.getBillingDataUser(this.authUser.id);
            //this.catalogue.getBankBillAccountProvider(this.authUser.id);

        }
    },
    created() {
        Event.$on("event-show-addBill", async (account, user_approved = {}, pay = {}) => {
            if (account.id && user_approved.id) {
                this.userCheck = user_approved.name + ' ' + user_approved.last_name;
            }
            if (account.id && pay.length > 0) {
                this.userPay = pay[0].user_approved.name + ' ' + pay[0].user_approved.last_name;
            }
            if (account.id) {
                this.bill=account;
                this.load = true;
                this.form.id = account.id;
                this.form.name = account.name;
                this.form.description = account.description;
                this.form.user_id = account.provider_id;
                this.form.billing_data_id = account.billing_data_id;
                this.form.bank_account_providers_id = account.bank_account_providers_id;

                // this.form.change_date= account.change_date;
                // this.form.exchange_rate= account.exchange_rate;
                // this.form.amount_usd= account.amount_usd;

                if (account.file) {
                    this.file = account.file;
                }
                // if (account.xml) {
                //     this.xml = account.xml;
                // }
                if (account.files) {
                    this.files = account.files;
                }
            }
            this.$modal.show('addBill');
        });
        Event.$on("event-show-addBillPettyCash", async(petty_cash) => {
            console.log('petty_cash');
            console.log(petty_cash);
            this.petty_cash = petty_cash.id;
            this.form.name = "caja chica #"+petty_cash.id;
            this.form.description = "caja chica #"+petty_cash.id;
            this.form.company_id = petty_cash.company_id;
            this.form.biill_type_id = petty_cash.type_id;
            this.form.subtotal = petty_cash.amount;
            this.$modal.show('addBill');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="addBill" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBills" method="post" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información Factura</h5>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col-md-12 mb-3">
                        <div class="row justify-content-start">
                            <!-- <div class="col-md-4" :style="form.currency_id == 2 ? 'padding-top: 30px' : ''">
                                <label v-for="(currency, index) in catalogue.currencies" :key="index" class="ml-1">
                                    {{ currency.name }} <input :disabled="!prop_edit" v-model="form.currency_id"
                                        :value="currency.id" type="radio" name="currency">
                                </label>
                            </div>

                            <div class="col-md-4" v-if="form.currency_id == 2">
                                <label> Fecha tipo de cambio </label>
                                <date-picker v-model="form.change_date" :disabled="!prop_edit"
                                    valueType="format"></date-picker>
                                <div v-if="errors && errors.change_date" class="text-danger">{{ errors.change_date[0] }}</div>
                            </div>
                            <div class="col-md-4" v-if="form.currency_id == 2">
                                <label> Tipo de cambio </label>
                                <money :disabled="!prop_edit" class="form-control" v-model="form.exchange_rate"></money>
                                <div v-if="errors && errors.exchange_rate" class="text-danger">{{ errors.exchange_rate[0] }}</div>
                            </div> -->
                            <!-- <div class="col-md-3" v-if="form.currency_id == 2">
                                <label> Monto USD </label>
                                <money :disabled="!prop_edit" :keyup="calcTotalUSD()" class="form-control" v-model="form.amount_usd"></money>
                                <div v-if="errors && errors.amount_usd" class="text-danger">{{ errors.amount_usd[0] }}</div>
                            </div>                 
                                      -->
                            <div class="col-md-4 text-center" v-if="userCheck != ''">
                                <label> Aprobó orden de pago  </label><br>
                               {{ userCheck }}
                            </div>

                            <div class="col-md-4 text-center" v-if="userPay != ''">
                                <label> Aprobó pago  </label><br>
                               {{ userPay }}
                            </div>
                           
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label>PDF</label><br>
                        <div class="custom-file" :style="file != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_file">
                            <label class="custom-file-label text-left" for="customFile">{{ fileName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${file}`" v-if="file != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                    </div>
                    <!-- <div class="col-md-6">
                        <label>XML</label><br>
                        <div class="custom-file" :style="xml != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" id="fileXML" class="custom-file-input"
                                :class="xml != '' ? 'pr-5' : ''" ref="file" @change="catch_xml">
                            <label class="custom-file-label text-left" for="customFile">{{ xmlName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${xml}`" v-if="xml != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.xml" class="text-danger">{{ errors.xml[0] }}</div>
                    </div> -->

                    <div class="col-md-12" v-if="authUser.organization_charts_id != 2">
                        <label>Residente</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.user_id">
                            <option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">{{ user.name }} {{ user.last_name }}</option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Datos de Facturación</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.billing_data_id">
                            <option value="">Sin datos de facturación</option>
                            <option v-for="(billD, index) in catalogue.billing_data_user" :value="billD.id"
                                :key="index">{{ billD.business_name }} - {{ billD.rfc }}</option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Cuenta Bancaria</label>
                        <select :disabled="!prop_edit" type="text" class="form-control"
                            v-model="form.bank_account_providers_id">
                            <option value="">Sin cuenta bancaria</option>
                            <option v-for="(bank, index) in catalogue.bank_bill_account_provider" :value="bank.id"
                                :key="index">
                                {{
        bank.bank.name }} - {{ bank.account_number }}</option>
                        </select>
                        <div v-if="errors && errors.bank_account_providers_id" class="text-danger">{{
        errors.bank_account_providers_id[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Concepto</label>
                        <input :disabled="!prop_edit" type="text" class="form-control" v-model="form.name">
                        <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Folio Fiscal</label>
                        {{ bill.tax_folio }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Folio</label>
                        {{ bill.folio }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Fecha de emisión</label>
                        {{ bill.date | toDateTime }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Subtotal</label>
                        {{ bill.subtotal | toCurrency }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>IVA</label>
                        {{ bill.iva | toCurrency }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>IEPS</label>
                        {{ bill.ieps | toCurrency }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>ISR RET</label>
                        {{ bill.isr_ret | toCurrency }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>IVA RET</label>
                        {{ bill.iva_ret | toCurrency }}
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Descuento</label>
                        {{ bill.discount | toCurrency }}
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Total</label>
                        {{ bill.amount | toCurrency }}
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Tipo</label>
                        {{ bill.type.name }}
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Empresa</label>
                        {{bill.company.name }}
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Descripción</label>
                        <textarea :disabled="!prop_edit" type="text" class="form-control"
                            v-model="form.description"></textarea>
                        <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                    </div>
                    <div class="col-12">
                        <hr>
                        <div class="row">
                            <div class="col-12 text-center">
                                <h3>Archivo adjuntos.</h3>
                                <p>Máximo 15 archivos.</p>
                                <div class="row mt-4 mb-4">
                                    <div class="col-12" v-if="(form.files.length + files.length) == 0">
                                        <i class="fa-solid fa-file fa-4x"></i>
                                        <p>Sin archivos adjuntos</p>
                                    </div>
                                    <div class="col-md-4 col-12 p-2" v-for="(fAdd, index_fAdd) in files"
                                        :key="index_fAdd" v-show="files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImgUpload(index_fAdd)">
                                                <i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="`${globalUrlFiles}${fAdd.file}`" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ fAdd.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
                                        :key="index_img" v-show="form.files.length > 0">
                                        <div class="card shadow">
                                            <button v-if="prop_edit" class="btn btn-sm btn-danger del" type="button"
                                                @click="delImg(index_img)"><i class="fa fa-trash"></i></button>
                                            <div class="card-body text-center">
                                                <a :href="createURL(img)" target="_blank">
                                                    <i class="fa fa-file fa-4x"></i>
                                                    <p>{{ img.name }}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="input-group mb-3"
                                    v-if="(form.files.length + files.length) <= 14 && prop_edit">
                                    <div class="custom-file" @change="uploadFilesBill">
                                        <input type="file" class="custom-file-input" id="inputGroupFile03"
                                            aria-describedby="inputGroupFileAddon03">
                                        <label class="custom-file-label" for="inputGroupFile03">
                                            Subir Archivo
                                        </label>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>